import {atom} from 'recoil';

export const healthDeclaration = atom({
  key: 'healthDeclaration',
  default: null,
});

export const healthDeclarationFilled = atom({
  key: 'healthDeclarationFilled',
  default: null,
});
